import { useEffect, useState } from 'react';
import { ctaService, DEFAULT_CTA_CONTENT } from '../Model/Services/ctaService.js';

export { DEFAULT_CTA_CONTENT };

export const useCTAContent = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const fetchContent = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await ctaService.get();
      setContent(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  const saveContent = async (data) => {
    setSaving(true);
    setError(null);
    try {
      const saved = await ctaService.upsert(data);
      setContent(saved);
      return saved;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setSaving(false);
    }
  };

  return {
    content,
    loading,
    error,
    saving,
    refresh: fetchContent,
    saveContent,
  };
};
